export default __webpack_public_path__ + "static/media/success.8592370a.gif";